module.exports = __webpack_public_path__ + "img/Group 1419 (2).0eb0c892.png";